class DateView {
  constructor(container$) {
    this.container$      = container$;
    this.dayCheckbox$    = container$.find('input[data-voc-krammer-date-day]');
    this.periodCheckbox$ = container$.find('input[data-voc-krammer-date-period]');
    this.submit$         = container$.find('input[data-voc-krammer-date-submit]');
    this.startsAtDay$    = container$.find('input[data-voc-krammer-date-startsat-day]');
    this.startsAtMonth$  = container$.find('input[data-voc-krammer-date-startsat-month]');
    this.startsAtYear$   = container$.find('input[data-voc-krammer-date-startsat-year]');
    this.endsAtDay$      = container$.find('input[data-voc-krammer-date-endsat-day]');
    this.endsAtMonth$    = container$.find('input[data-voc-krammer-date-endsat-month]');
    this.endsAtYear$     = container$.find('input[data-voc-krammer-date-endsat-year]');

    this.bindEvents();
  }

  bindEvents() {
    this.container$.on('submit', this.buildFormAction.bind(this));
  }

  buildFormAction() {
    var date, action, base;

    if (this.dayCheckbox$.is(':checked')) {
      date = `${this.startsAtYear$.val()}${_formatDate(this.startsAtMonth$.val())}${_formatDate(this.startsAtDay$.val())}`;
    } else {
      date = `${this.startsAtYear$.val()}${_formatDate(this.startsAtMonth$.val())}${_formatDate(this.startsAtDay$.val())}`;
      date += `-${this.endsAtYear$.val()}${_formatDate(this.endsAtMonth$.val())}${_formatDate(this.endsAtDay$.val())}`;
    }

    action = `${date}.html`;
    base = this.container$.attr('action') || '';

    document.location.href = `${base}${action}`;

    return false;
  }
}

export default DateView;

/* Private */

function _formatDate(d) {
  if (d < 10 && d.length === 1) {d = `0${d}`;}
  return d;
}



// WEBPACK FOOTER //
// ./src/views/date.js